import { useContext, useEffect, useState } from "react"
import services from "../../../services/services"
import { Urls } from "../../../services/Urls"
import { dateConvert } from "../../../utils/Helper";
import * as XLSX from 'xlsx';
import { ToastContext } from "../../../context/ToastContext";
import _ from 'underscore'

export const useBuildReport = ({ filterValues, setFilterValues }) => {
    const { showInfo } = useContext(ToastContext);
    const [rowData, setRowData] = useState([]);
    const [loader, setLoader] = useState({
        outer: false,
        inner: false
    });
    const [showPopup, setShowPopup] = useState({ show: false });

    useEffect(() => {
        filterValues?.apiCall && getProbBuild()
    }, [filterValues?.apiCall])

    useEffect(() => {
        filterValues?.excelDownload && exportBuildSummaryToExcel()
    }, [filterValues?.excelDownload])

    const columnConfigs = [
        { label: "Regular Build", key: "regular_build", type: "regular_build" },
        { label: "HotFix", key: "hotfix", type: "hotfix" },
        { label: "Feature Release", key: "feature_release", type: "feature_build" },
        { label: "DB Update", key: "flyway", type: "flyway" },
        { label: "Total", key: "total", type: "" },
    ];

    const columns = [
        {
            label: "Project",
            key: "project_Name",
            style: { width: "25%" },
            render: (row) => <div className="px-2 fw-bold">{row?.project_Name}</div>
        },
        ...columnConfigs.map(({ label, key, type }) => ({
            label,
            key,
            headerStyle: { textAlign: "center" },
            style: { width: "15%", textAlign: "center", fontWeight: "600" },
            render: (row) => (
                <div
                    className="c-pointer"
                    onClick={() => {
                        if (row?.[key] > 0) {
                            setShowPopup(prev => ({ ...prev, show: true, data: row, type: label, count: key }));
                            getBuildReportDetails(row?.project_id, type);
                        }
                    }}
                >
                    {row?.[key]}
                </div>
            )
        }))
    ];

    // build details columns
    const detailsColumns = [
        {
            label: "Type",
            key: "build_type_name",
            style: { width: "10%" }
        },
        {
            label: "Datetime",
            key: "apply_datetime",
            style: { width: "15%" },
            render: (row) => <div className="px-2">{dateConvert(row?.apply_datetime, "date-time-months")}</div>
        },
        {
            label: "Status",
            key: "request_status_name",
            headerStyle: { textAlign: "center" },
            style: { width: "10%", textAlign: "center", },
            render: (row) => {
                let style;
                if (row?.request_status_name === "Success") {
                    style = { color: "#047857", background: "#d1fae5" }
                }
                if (row?.request_status_name === "Failed") {
                    style = { color: "#be123c", background: "#ffe4e6" }
                }
                return <div className="px-2" >
                    <span style={style} className="px-2 rounded fw-semibold">{row?.request_status_name}</span>
                </div>
            }
        },
        {
            label: "Module",
            key: "project_module_names",
            style: { width: "20%" },
        },
        {
            label: "Requested By",
            key: "requested_user_name",
            style: { width: "12%" },
        },
        {
            label: "Approver 1",
            key: "devops_user_name",
            style: { width: "12%" },
        },
        {
            label: "Approver 2",
            key: "client_user_display_name",
            style: { width: "12%" },
        },
        {
            label: "Services",
            key: "services",
            headerStyle: { textAlign: "center" },
            style: { width: "9%", textAlign: "center" },
        render: (row) => <div className="c-pointer" onClick={() => setShowPopup((prev) => ({ ...prev, showJob: true, jobs: row?.job_names?.split(',') }))}>{row?.services}</div>
        }
    ]

    const getProbBuild = async () => {
        try {
            setLoader((prev) => ({ ...prev, outer: true }))
            const payload = {
                "project_ids": _.pluck(filterValues.projects, "project_id").toString() || "",
                "year": filterValues?.year?.toString() || "",
                "month": filterValues?.month?.toString() || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTSBUILDREPORTDETAILS"), payload)
            if (!res.body.error_status) {
                setLoader((prev) => ({ ...prev, outer: false }))
                setFilterValues((prev) => ({ ...prev, apiCall: false, isChange: false }))
                setRowData([{
                    id: "all",
                    title: "",
                    children: res?.body?.data?.projects_build_report_details
                }
                ])
            }
             setFilterValues((prev) => ({ ...prev, apiCall: false }))
        } catch (error) {
            setLoader((prev) => ({ ...prev, outer: false }))
             setFilterValues((prev) => ({ ...prev, apiCall: false }))
            console.error("error", error)
        }
    }

    const getBuildReportDetails = async (projectId, type) => {
        try {
            setLoader((prev) => ({ ...prev, inner: true }))
            const payload = {
                project_ids: projectId?.toString() || "",
                build_type_key: type || "",
                year: filterValues?.year?.toString() || "",
                month: filterValues?.month?.toString() || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("GETBUILDREPORTDETAILS"), payload)
            if (!res.body.error_status) {
                setLoader((prev) => ({ ...prev, inner: false }))
                setFilterValues((prev) => ({ ...prev, apiCall: false, isChange: false }))
                setShowPopup((prev) => ({
                    ...prev, rowData: [{
                        id: "all",
                        title: "",
                        children: res?.body?.data?.build_report_details
                    }]
                }))
            }
        } catch (error) {
            setLoader((prev) => ({ ...prev, inner: false }))
            console.error("error", error)
        }
    }

    // Download the build report details
    const BuildDetailsExportToExcel = () => {
        const rawData = showPopup?.rowData[0]?.children?.map(row => ({
            "Type": row.build_type_name || '-',
            "Datetime": dateConvert(row.apply_datetime, "date-time-months"),
            "Status": row.request_status_name || '-',
            "Module": row.project_module_names || '-',
            "Requested By": row.devops_user_name || '-',
            "Approver 1": row.devops_user_name || '-',
            "Approver 2": row.client_user_display_name || '-',
            "Services": row.services || '-',
            "Job Names": row.job_names || '-'
        }));
        const objectMaxLength = [];
        const worksheetData = [{}, ...rawData];
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        worksheetData.forEach((row) => {
            Object.keys(row).forEach((key, index) => {
                const value = row[key] ? row[key].toString() : "";
                const headerLen = key.length;
                const valueLen = value.length;
                objectMaxLength[index] = Math.max(
                    objectMaxLength[index] || headerLen,
                    valueLen
                );
            });
        });

        worksheet['!cols'] = objectMaxLength.map(width => ({
            width: width + 2
        }));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "BuildDetails");

        XLSX.writeFile(workbook, "Build_Details.xlsx");
    };

    // Download the build report summary
    const exportBuildSummaryToExcel = () => {
        if (!_.isEmpty(rowData) && rowData[0]?.children?.length <= 0) {
            showInfo("Info", "There is no data to download");
            setFilterValues((prev) => ({ ...prev, excelDownload: false }))
            return;
        }
        const rawData = rowData[0]?.children?.map(row => {
            const rowObj = {};
            rowObj["Project"] = row.project_Name || '-';
            columnConfigs.forEach(config => {
                rowObj[config.label] = row[config.key] || 0;
            });
            return rowObj;
        });

        const worksheetData = [{}, ...rawData];
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const objectMaxLength = [];
        const headers = Object.keys(rawData[0] || {});

        headers.forEach((key, index) => {
            let maxLen = key.length;

            rawData.forEach(row => {
                const value = row[key] ? row[key].toString() : "";
                if (value.length > maxLen) {
                    maxLen = value.length;
                }
            });
            objectMaxLength[index] = maxLen + 5
        });

        worksheet['!cols'] = objectMaxLength.map(width => ({ width }));
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "BuildSummary");
        XLSX.writeFile(workbook, "Build_Summary_Report.xlsx");
        setFilterValues((prev) => ({ ...prev, excelDownload: false }))
    };

    return {
        rowData, columns, loader, detailsColumns, showPopup, setShowPopup, BuildDetailsExportToExcel
    }
}